import { setLoader, unSetLoader, setErrorMessage } from "./appActions";
import { SET_REPORT_TYPE } from "./actionTypes";
import { AGING_INSURANCE_REPORT } from "utils/data";
import { billing } from "store/requests";

export const getChargeEntryReports = async (payload) => {
  try {
    let response = await billing({
      url: "/getChargeEntryList",
      payload,
    });
    const patientDetails = response.data["success"].map((p) => {
      return {
        ...p,
        id: p.charge_entry_id,
        patient_name: p.first_name + " " + p.last_name,
        status: p.status || "",
      };
    });
    return patientDetails;
  } catch (error) {
    console.error(error);
  }
};

export const getReportMaster = () => {
  return async (dispatch, store) => {
    try {
      dispatch(setLoader());
      const payload = {
        type: "ReportMaster",
        practice_id: store().auth.authData?.selected_practice,
      };
      let { data } = await billing({
        url: "/getReportMaster",
        payload,
      });
      let temp = {
        [AGING_INSURANCE_REPORT]: [
          {
            id: 100,
            report_group: AGING_INSURANCE_REPORT,
            report_id: "AIR_1",
            report_name: AGING_INSURANCE_REPORT,
          },
        ],
      };
      for (let i of data) {
        if (temp[i.report_group]) {
          temp[i.report_group].push(i);
        } else {
          temp[i.report_group] = [i];
        }
      }
      const temp_array = Object.keys(temp)
        .sort()
        .map((group) => {
          return {
            title: group,
            reports: temp[group],
          };
        });
      dispatch(unSetLoader());
      dispatch({
        type: SET_REPORT_TYPE,
        types: temp_array,
      });
      return temp_array;
    } catch (error) {
      dispatch(
        setErrorMessage(
          error?.response?.data?.error
            ? error.response.data.error
            : error.message
        )
      );
      dispatch(unSetLoader());
    }
  };
};

export const getReport = (payload) => {
  return async (dispatch) => {
    try {
      let { data } = await billing({
        url: "/getReport",
        payload,
      });
      return data;
    } catch (error) {
      dispatch(
        setErrorMessage(
          error?.response?.data?.error
            ? error.response.data.error
            : error.message
        )
      );
    }
  };
};

export const generateInsAgeingReport = async (payload) => {
  try {
    let response = await billing({
      url: "/generateInsAgeingReport",
      payload,
    });
    const url = window.URL.createObjectURL(
      new Blob([response.data], { type: "application/pdf" })
    );
    window.open(
      url,
      "_blank",
      "location=yes,height=570,width=520,scrollbars=yes,status=yes"
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};
